<script>
import detalhesTemplateItem from './components/detalhesTemplateItem.vue'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'
// import { loading } from '@/shared/utils/UIHelper'

const name = 'detalhesTemplate'
export default {
  name,

  components: { detalhesTemplateItem },

  props: {
    revisao: {
      require: true
    },
    aprId: {
      require: true
    }
  },

  mounted () {
    this.getAPRTemplateDetalhesRiscoCausaByI(this.aprId, this.revisao)
  },

  updated () { },

  data () {
    return { dataTemplateAPR: [] }
  },

  methods: {
    getAPRTemplateDetalhesRiscoCausaByI (aprId, numRevisao = undefined) {
      // loading.push()
      const numRevisaoPayload = numRevisao || this.revisao
      aprTemplate.GetAPRTemplateDetalhesRiscoCausaById(aprId, numRevisaoPayload)
        .then((r) => {
          console.info(r)
          this.dataTemplateAPR = r.data.data
        })
        // .finnaly(() => {
        //   // loading.pop()
        // })
    }
  },

  computed: { }

}

</script>

<template>
    <ol class="detalhes-template-container">
      <detalhesTemplateItem
        v-for="(dataRisco,index) in dataTemplateAPR"
        :key="index"
        :dataRisco="dataRisco"
        />
    </ol>
</template>

<style scoped>
.detalhes-template-container{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: fit-content;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/detalhesTemplate/detalhesTemplate.vue